import { PageOptionsRequestDto } from './page-options-request.dto';
import { RadiusUnitEnum } from '../../..';

export class PlacePageOptionsDto extends PageOptionsRequestDto {
  radius?: number;
  radiusUnit: RadiusUnitEnum;
}
